// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Hero__Wrapper_21JYX","Title":"Hero__Title_BwLAK","Lead":"Hero__Lead_3oPY0 grid","Factoids":"Hero__Factoids_3GLQf"};